export const LOAD_COLOR_BG = 'bg-gray-300';
